<template>

    <v-card>

        <v-card-title class="headline text-xs-center">{{ $t('Material.ForgotPassword.title') }}</v-card-title>

        <v-card-text v-show="!isLoading">
            <v-alert
                    v-model="passwordResetting"
                    outline
                    type="success">
                {{ $t('Material.ForgotPassword.alert') }}
            </v-alert>

            <v-flex v-show="!passwordResetting" class="text-xs-center">
                {{ $t('Material.ForgotPassword.message') }}
                <v-form action="#" v-model="valid" @submit.prevent="resetPassword" @keyup.enter="resetPassword">
                    <v-text-field autofocus :rules="rules.username" required v-model="username"
                                  class="login-text-input" type="text"
                                  v-bind:placeholder="$t('Views.Login.username-placeholder')"></v-text-field>
                </v-form>
            </v-flex>
        </v-card-text>

        <v-card-text v-show="isLoading" class="text-xs-center">
            {{ $t('Material.ForgotPassword.wait') }}
            <v-progress-linear
                    indeterminate
                    color="red"
                    class="mb-0"
            ></v-progress-linear>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="closeMe()">
                {{ $t('Material.ForgotPassword.close') }}
            </v-btn>
            <v-btn v-if="!passwordResetting" color="danger" class="danger" flat @click="resetPassword()">
                {{ $t('Material.ForgotPassword.reset') }}
            </v-btn>
        </v-card-actions>


        <v-snackbar
                v-model="snackbar.show"
                :color="snackbar.color"
                :timeout="snackbar.timeout"
                top>
            {{ snackbar.text }}
        </v-snackbar>

    </v-card>
</template>


<script>
    import httpService from '@/service/httpService'

    export default {
        props: {
            service: String
        },
        data() {
            const _me = this;
            return {
                username: '',
                actualService: '',
                isLoading: false,
                valid: false,
                passwordResetting: false,
                rules: {
                    username: [val => (val || '').length > 0 || _me.$t('Material.ForgotPassword.field-required')]
                },
                snackbar: {
                    show: false,
                    color: '',
                    timeout: 6000,
                    text: ''
                }
            }
        },
        created() {
            this.actualService = this.service;
        },
        methods: {
            resetPassword() {
                if (this.valid) {
                    this.isLoading = true
                    this.passwordResetting = true
                    httpService.get('/users/' + this.username + '/forgot-password' + ((this.service.length) ? '?service=' + this.service : ''))
                        .then(() => {
                            this.isLoading = false
                        }).catch((err) => {
                        if (err.response.status === 404) {
                            this.errorMessage('Material.ForgotPassword.user-not-found')
                        } else {
                            this.errorMessage('Material.ForgotPassword.reset-error')
                        }
                        this.isLoading = false
                        this.passwordResetting = false
                    });
                } else {
                    this.errorMessage('Material.ForgotPassword.username-required')
                }
            },
            closeMe() {
                this.$emit('close-modal')
            },
            errorMessage(key) {
                this.snackbar.text = this.$t(key)
                this.snackbar.color = 'error'
                this.snackbar.show = true
            },
            successMessage(key) {
                this.snackbar.text = this.$t(key)
                this.snackbar.color = 'success'
                this.snackbar.show = true
            }
        }
    }

</script>
